
export default function Logo() {
  return (
    <div className="logo m-2">
      <img alt="Papermerge logo" width="112" height="108" src="/images/papermerge4.svg" />
    </div>
  );
}
